import React from 'react';
import './DownloadableGISData.css';

class DownloadGISDataForm extends React.Component {
    // Then we add our constructor which receives our props
    constructor(props) {
        super(props);
        let dataChkGISState = localStorage.getItem("dataChkGISState");
        if (dataChkGISState) {
            dataChkGISState = JSON.parse(dataChkGISState);
        }
        else {
            dataChkGISState = [];
        }
        this.state = {
            stateDownloadDatas: [],
            dataChkGISState: dataChkGISState
        }

    }

    componentDidMount() {
        fetch('api/DownloadStateDataForm/GetDownloadGISState')
            .then(response => response.json())
            .then(data => {
                //console.log({ data,myThis:this });
                this.setState({ stateDownloadDatas: data.dataReturn });
                this.assignLastChkGISState();
                //this.setState({ buffers: data, selectedOption: data[0].value, loading: false });
            });
    }

    assignLastChkGISState() {
        let stateDatas = this.state.stateDownloadDatas;
        let lastDatas = this.state.dataChkGISState;

        for (var i = 0; i < stateDatas.length; i++) {
            let stateData = stateDatas[i];
            for (var u = 0; u < lastDatas.length; u++) {
                let lastData = lastDatas[u];
                if (stateData.productId === lastData.productId && lastData.checked) {
                    let chk = document.getElementsByName("chk_" + stateData.productId)[0];
                    chk.checked = true;
                    stateData.checked = true;
                }
            }
        }

        this.generateTotalCost();
    }

    generateTotalCost() {
        let stateDatas = this.state.stateDownloadDatas;
        let totalCost = 0;
        for (var i = 0; i < stateDatas.length; i++) {
            let stateData = stateDatas[i];
            if (stateData.checked) {
                totalCost += Number(stateData.price);
            }
        }
        this.showTotalCost(totalCost);
    }

    showTotalCost(totalCost) {
        this.setState({ totalCost: "Total Amount: RM " + totalCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") });
    }

    applyMalaysiaChecked() {
        let stateDatas = this.state.stateDownloadDatas;

        for (let i = 0; i < stateDatas.length; i++) {
            let stateData = stateDatas[i];
            if (stateData.name !== "Malaysia") {
                let chk = document.getElementsByName("chk_" + stateData.productId)[0];
                chk.checked = false;
                stateData.checked = false;
            }
        }
    }

    unCheckMalaysia() {
        let stateDatas = this.state.stateDownloadDatas;

        for (let i = 0; i < stateDatas.length; i++) {
            let stateData = stateDatas[i];
            if (stateData.name === "Malaysia") {
                let chk = document.getElementsByName("chk_" + stateData.productId)[0];
                chk.checked = false;
                stateData.checked = false;
            }
        }
    }

    checkState(e, id) {
        let stateDatas = this.state.stateDownloadDatas;
        //console.log({ e: e.target, id });
        for (var i = 0; i < stateDatas.length; i++) {
            let stateData = stateDatas[i];
            if (stateData.productId === id) {
                if (!stateData.checked) {
                    stateData.checked = true;
                }
                else {
                    stateData.checked = false;
                }
                if (stateData.name === "Malaysia" && stateData.checked) {
                    this.applyMalaysiaChecked();
                }
                else {
                    this.unCheckMalaysia();
                }
            }
        }
        this.saveChkToLocalStorage();
        this.generateTotalCost();
        //console.log({ gg: this.state.stateDownloadDatas });
    }

    saveChkToLocalStorage() {
        localStorage.setItem("dataChkGISState", JSON.stringify(this.state.stateDownloadDatas));
    }

    render() {
        return (
            <div className="background-color">
                <div className="container-downloadable">
                    <ul className="responsive-table">
                        <li className="table-header">
                            <div className="col col-1">No.</div>
                            <div className="col col-4">State Name</div>
                            <div className="col col-2">Amount</div>
                            <div className="col col-3 text-center">Select</div>
                        </li>
                        {this.state.stateDownloadDatas.map((stateData, i) => (
                            <li className="table-row" key={i}>
                                <div className="col col-1" data-label="">{i+1}</div>
                                <div className="col col-4" data-label="">{stateData.name}</div>
                                <div className="col col-2 text-right" data-label=""> RM {stateData.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
                                <div className="col col-3 custom-control custom-checkbox text-center" data-label="">
                                    <input type="checkbox" className="custom-control-input" value={stateData.productId} id={'chk_' + stateData.productId} name={'chk_' + stateData.productId} onChange={(e) => { this.checkState(e, stateData.productId) }} />
                                    <label className="custom-control-label" htmlFor={'chk_' + stateData.productId}></label>
                                </div>
                            </li>
                        ))}
                    </ul>
                    <div id="totalCost"><span className="total-cost">{this.state.totalCost}</span></div>
                    <div className="pl-4">
                        <button type="button" className="btn btn-primary width100" onClick={() => this.props.addToCartGISData()}> Add to cart </button>
                    </div>
                </div>

                
            </div>
        )
    }
}

export default DownloadGISDataForm;


// WEBPACK FOOTER //
// ./src/components/DownloadableGISData/DownloadGISDataForm.js